// src/components/Events/EventsManager.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEvents,
  insertEvent,
  updateEvent,
  deleteEvent,
} from "../../../store/eventsSlice";

import { fetchICTData }   from "../../../store/uiSlice";
import { fetchEmployees } from "../../../store/empDataSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../Styles/Common.css";
const user = JSON.parse(localStorage.getItem("user"));
const userRole = user?.role || null;
const isReadOnly = userRole === "sales";

function EventsManager() {
  const dispatch = useDispatch();

  /* ───── global slices ───── */
  const { items: events = [], loading, error } = useSelector(s => s.events);
  const { ictData = [] }     = useSelector(s => s.ui);
  const { employees = [] }   = useSelector(s => s.empData);

  /* ───── UI state ───── */
  const [popup, setPopup] = useState(false);
  const [editMode, setEdit] = useState(false);
  const [search, setSearch] = useState("");

  /* form state  */
  const blank = {
    id: "",
    ict_id: "",
    eventTitle: "",
    eventType: "webinar",
    eventDesc: "",
    eventDate: "",
    eventSpeaker: "",
    eventPic: null,     // File
    eventDuration: "",
    status: "A",
  };
  const [form, setForm] = useState(blank);

  /* type-ahead for ICT  */
  const [ictTxt,setIctTxt]=useState(""); const [ictSug,setIctSug]=useState([]);
  const onIctType = v=>{
    setIctTxt(v);
    setIctSug(v.length>=2 ? ictData.filter(i=>i.ictName.toLowerCase().includes(v.toLowerCase())):[]);
  };
  const pickIct = ict=>{
    setForm(p=>({...p,ict_id:ict.id}));
    setIctTxt(ict.ictName); setIctSug([]);
  };

  /* type-ahead for speaker  */
  const [spTxt,setSpTxt]=useState(""); const [spSug,setSpSug]=useState([]);
  const onSpType = v=>{
    setSpTxt(v);
    setSpSug(v.length>=2 ? employees.filter(e=>
      (`${e.empFName} ${e.empLName}`).toLowerCase().includes(v.toLowerCase())):[]);
  };
  const pickSp = emp=>{
    setForm(p=>({...p,eventSpeaker:emp.id}));
    setSpTxt(`${emp.empFName} ${emp.empLName}`); setSpSug([]);
  };

  /* initial fetch */
  useEffect(()=>{
    dispatch(fetchEvents());
    dispatch(fetchICTData());
    dispatch(fetchEmployees());
  },[dispatch]);
  const sanitizeUrl = (url) => url.replace(/([^:])\/\//g, "$1/");

  /* handlers */
  const handleFile = e=>{
    if(e.target.files[0]) setForm(p=>({...p,eventPic:e.target.files[0]}));
  };

  const save = async e=>{
    e.preventDefault();
    try{
      if(editMode){
        await dispatch(updateEvent(form)).unwrap();
        toast.success("Event updated");
      }else{
        await dispatch(insertEvent(form)).unwrap();
        toast.success("Event added");
      }
      setPopup(false); setForm(blank); setIctTxt(""); setSpTxt("");
    }catch(err){ toast.error("Save failed"); }
  };

  const startAdd = ()=>{
    setForm(blank); setEdit(false); setPopup(true);
    setIctTxt(""); setSpTxt("");
  };

  const startEdit = ev=>{
    setForm({...ev,eventPic:null}); setEdit(true); setPopup(true);
    setIctTxt(ictData.find(i=>i.id===ev.ict_id)?.ictName||"");
    const emp = employees.find(e=>e.id===ev.eventSpeaker);
    setSpTxt(emp?`${emp.empFName} ${emp.empLName}`:"");
  };

  const del = async id=>{
    if(window.confirm("Delete this event?")){
      try{ await dispatch(deleteEvent(id)).unwrap(); toast.success("Deleted"); }
      catch{ toast.error("Delete failed"); }
    }
  };

  /* filter */
  const shown = events.filter(e=>e.eventTitle.toLowerCase().includes(search.toLowerCase()));

  /* UI */
  return(
    <div className="trainer-container">
      <ToastContainer position="bottom-right" autoClose={2500}/>
      <div className="header-container">
        <h2>Events</h2>
        {!isReadOnly && (
        <button className="add-lead-btn" onClick={startAdd}><i className="fa fa-plus"/></button>
        )}
      </div>

      <input className="filter-input" placeholder="search title..."
             value={search} onChange={e=>setSearch(e.target.value)}/>

      {loading && <p>loading…</p>}
      {error && <p className="error">{error}</p>}

      <table className="table">
        <thead>
          <tr>
            <th>#</th><th>ICT</th><th>Title</th><th>Type</th><th>Date</th>
            <th>Speaker</th>
            <th>Dur (min)</th>
            <th>Pic</th>
            <th>Status</th>
            {!isReadOnly && (
                <th>Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {shown.map((ev,i)=>{
            const ict = ictData.find(d=>d.id===ev.ict_id);
            const emp = employees.find(e=>e.id===ev.eventSpeaker);
            return(
              <tr key={ev.id}>
                <td>{i+1}</td>
                <td>{ict?.ictName||ev.ict_id}</td>
                <td>{ev.eventTitle}</td>
                <td>{ev.eventType}</td>
                <td>{new Date(ev.eventDate).toLocaleString()}</td>
                <td>{emp?`${emp.empFName} ${emp.empLName}`:"-"}</td>
                <td>{ev.eventDuration}</td>
                <td>
                  {ev.eventPic
                    ? <img
                        src={sanitizeUrl(`https://iteyonikservicesinstitute.com/${ev.eventPic}`)}
                        alt="ICT Event"
                        className="ict-img"
                        width="80"
                        height="50"
                    />
                    : "—"}
                </td>
                <td>{ev.status}</td>
                    {!isReadOnly && (
                    <td>
                      <button className="icon-btn update-btn fa fa-edit" onClick={()=>startEdit(ev)}/>
                      <button className="icon-btn delete-btn fa fa-trash"onClick={()=>del(ev.id)}/>
                    </td>
                    )}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* ───────── popup form ───────── */}
      {popup && !isReadOnly && 
        <div className="popup-overlay">
          <div className="popup-content">
            <h3>{editMode?"Edit":"Add"} Event</h3>
            <form onSubmit={save}>
              <div className="form-group">
                <label>ICT</label>
                <input value={ictTxt} onChange={e=>onIctType(e.target.value)} required/>
                {ictSug.length>0 && (
                  <div className="suggestions-dropdown">
                    {ictSug.map(i=><div key={i.id} className="suggestion-item"
                                        onClick={()=>pickIct(i)}>{i.ictName}</div>)}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Title</label>
                <input value={form.eventTitle}
                       onChange={e=>setForm({...form,eventTitle:e.target.value})}
                       required/>
              </div>

              <div className="form-group">
                <label>Type</label>
                <select value={form.eventType}
                        onChange={e=>setForm({...form,eventType:e.target.value})}
                        required>
                  <option value="webinar">Webinar</option>
                  <option value="seminar">Seminar</option>
                </select>
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea value={form.eventDesc||""}
                          onChange={e=>setForm({...form,eventDesc:e.target.value})}/>
              </div>

              <div className="form-group">
                <label>Date & Time</label>
                <input type="datetime-local"
                       value={form.eventDate}
                       onChange={e=>setForm({...form,eventDate:e.target.value})}
                       required/>
              </div>

              <div className="form-group">
                <label>Speaker</label>
                <input value={spTxt} onChange={e=>onSpType(e.target.value)}/>
                {spSug.length>0 && (
                  <div className="suggestions-dropdown">
                    {spSug.map(emp=>
                      <div key={emp.id} className="suggestion-item"
                           onClick={()=>pickSp(emp)}>
                        {emp.empFName} {emp.empLName}
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="doubleFormField">
                <div className="form-group halfForm">
                  <label>Duration (minutes)</label>
                  <input type="number"
                         value={form.eventDuration}
                         onChange={e=>setForm({...form,eventDuration:e.target.value})}/>
                </div>
                <div className="form-group halfForm">
                  <label>Picture (jpg/png)</label>
                  <input type="file" accept="image/*" onChange={handleFile}
                         required={!editMode}/>
                </div>
              </div>

              <div className="form-group">
                <label>Status</label>
                <select value={form.status}
                        onChange={e=>setForm({...form,status:e.target.value})}>
                  <option value="A">Active</option>
                  <option value="D">Disabled</option>
                </select>
              </div>

              <div className="form-actions">
                <button type="submit">
                  {editMode?<i className="fa fa-save"/>:<i className="fa fa-plus-square"/>}
                </button>
                <button type="button" className="fa fa-close"
                        onClick={()=>setPopup(false)}/>
              </div>
            </form>
          </div>
        </div>}
    </div>
  );
}

export default EventsManager;
